//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    collaborator: {
      type: String,
      default: '',
    },
  },
}
